/* Lazy load code */
var sa = sa || {};
sa.lazyload = sa.lazyload || {};

sa.lazyload.config = {
	// If the image gets within 50px in the Y axis, start the download.
	rootMargin: '50px 0px',
	threshold: 0.01
}
sa.lazyload.observer = null;

sa.lazyload.setupObserver = function() {
	this.observer = new IntersectionObserver(function(entries, observer) {

	  entries.forEach(function (entry) {
		if (entry.intersectionRatio > observer.thresholds[0]) {
		  sa.lazyload.load(entry.target, observer);
		}
	  });    
	}, this.config);
}

// Load an image and unobserve it
sa.lazyload.load = function(img, observer) {
  if (observer) {
	img.addEventListener('load', function() { 
	  observer.unobserve(img);
	});
  }

  var dataSrc = img.dataset.src;

  if (dataSrc) {
  	sa.lazyload.tagPicture(img);
	img.setAttribute('src', dataSrc);
	img.removeAttribute("data-src");
  }
}

sa.lazyload.tagPicture = function(img) {
	var elPicture = img.closest('picture');
	if (!elPicture) return;

	var sources = elPicture.querySelectorAll('[data-srcset]');
	sources.forEach(function(source) {

		var image = source.dataset.srcset.trim();
		source.setAttribute('srcset', image);
		source.removeAttribute("data-srcset");

	});
}

sa.lazyload.init = function() {

	var images = document.querySelectorAll('img[data-src]');

	if ("IntersectionObserver" in window) {
		this.setupObserver();
		images.forEach(function(img) {
		  sa.lazyload.observer.observe(img);
		});
	} else {
		images.forEach(function(img) {
		  sa.lazyload.load(img);
		});
	}
}

document.addEventListener("DOMContentLoaded", function(event) { 
	sa.lazyload.init();
});